import api from "../index";

// ==================== ADMIN PROMPTS ====================

// Get admin's own prompts (paginated)
export const getMyPrompts = async (
  page: number = 1,
  perPage: number = 20,
  filters: {
    status?: string;
    visibility?: string;
    category?: string;
    search?: string;
  } = {}
) => {
  const params = new URLSearchParams({
    page: page.toString(),
    perPage: perPage.toString(),
  });

  if (filters.status) params.append("status", filters.status);
  if (filters.visibility) params.append("visibility", filters.visibility);
  if (filters.category) params.append("category", filters.category);
  if (filters.search) params.append("search", filters.search);

  return await api.get(`/prompts/my?${params.toString()}`);
};

// Get single prompt by ID (must be owned by user)
export const getMyPromptById = async (id: string) => {
  return await api.get(`/prompts/my/${id}`);
};

// Create a new prompt
export const createPrompt = async (data: {
  title: string;
  description?: string;
  content: string;
  category?: string;
  visibility?: string;
  variables?: any[];
  tags?: string[];
}) => {
  return await api.post("/prompts", data);
};

// Update prompt (must be owned by user)
export const updateMyPrompt = async (id: string, data: any) => {
  return await api.put(`/prompts/my/${id}`, data);
};

// Delete prompt (must be owned by user)
export const deleteMyPrompt = async (id: string) => {
  return await api.delete(`/prompts/my/${id}`);
};

// Submit prompt for public review
export const submitPromptForReview = async (id: string) => {
  return await api.post(`/prompts/my/${id}/submit-for-review`);
};

// Get prompt categories (public)
export const getPromptCategories = async () => {
  return await api.get("/prompts/categories");
};

// Get public prompts (for browsing)
export const getPublicPrompts = async (
  page: number = 1,
  perPage: number = 20,
  filters: {
    category?: string;
    search?: string;
    featured?: boolean;
  } = {}
) => {
  const params = new URLSearchParams({
    page: page.toString(),
    perPage: perPage.toString(),
  });

  if (filters.category) params.append("category", filters.category);
  if (filters.search) params.append("search", filters.search);
  if (filters.featured) params.append("featured", "true");

  return await api.get(`/prompts/public?${params.toString()}`);
};

// Save a prompt (bookmark)
export const savePrompt = async (promptId: string) => {
  return await api.post(`/prompts/${promptId}/save`);
};

// Unsave a prompt
export const unsavePrompt = async (promptId: string) => {
  return await api.delete(`/prompts/${promptId}/save`);
};

// Get saved prompts
export const getSavedPrompts = async (page: number = 1, perPage: number = 20) => {
  return await api.get(`/prompts/saved?page=${page}&perPage=${perPage}`);
};

// Use a prompt (increment usage count)
export const usePrompt = async (promptId: string) => {
  return await api.post(`/prompts/${promptId}/use`);
};
